<template>
  <!-- 头部整体盒子 -->

  <div
    id="header"
    class="container-fuild"
    :style="{ height: menuName === '关于矩仁' ? '85vh' : '60vh' }"
  >
    <!-- 电脑导航 -->
    <!-- <div
      ref="vantaRef"
      :style="{
        position: 'absolute',
        width: '100%',
        height: menuName === '关于矩仁' ? '85vh' : '60vh',
      }"
    ></div> -->
    <img
      :src="require(`@/assets/img/topImg/${img}.jpg`)"
      class="bg-class"
      :style="{ height: menuName === '关于矩仁' ? '85vh' : '60vh' }"
    />
    <div
      class="bg-text__index blur-out-contract"
      v-if="menuName === '关于矩仁'"
    >
      专业法律护航，正义永恒追求
    </div>
    <div
      class="bg-text blur-out-contract"
      v-else
    >
      <p>
        {{ menuName }}
      </p>
      <p style="font-size: 20px; letter-spacing: 20px; text-shadow: none">
        {{ activeMenu.imgText_En }}
      </p>
    </div>
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img
          src="@/assets/img/logo_tm.png"
          width="100%"
        />
      </div>

      <!-- 导航内容 -->
      <div class="header-nav-wrapper">
        <div
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as THREE from "three";
import FOG from "vanta/src/vanta.fog";
// 这里的"FOG"对应官网上的名字，vanta.fog和前面FOG需保持一致
import { Slide } from 'vue-burger-menu'
export default {
  name: "Header",
  components: {
    Slide // 注册你的组件
  },
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "关于矩仁",
      img: "index_bg_8",
      activeMenu: {
        name: "关于矩仁",
        imgSrc: "index_bg_8",
        imgText: "专业法律护航，正义永恒追求",
        imgText_En: "",
        path: "/",
        children: [],
      },
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "关于矩仁",
          imgSrc: "index_bg_8",
          imgText: "专业法律护航，正义永恒追求",
          imgText_En: "",
          path: "/",
          children: [],
        },
        {
          name: "经典案例",
          imgSrc: "slider-2",
          imgText_En: "SERVICE CASE",
          path: "/service",
          children: [],
        },
        {
          name: "业务领域",
          imgSrc: "slider-2",
          imgText_En: "BUSINESS AREA",
          path: "/area",
          children: [],
        },
        {
          name: "服务企业",
          imgSrc: "slider-2",
          imgText_En: "SERVICE ENTERPRISE",
          path: "/customer",
          children: [],
        },
        {
          name: "专业团队",
          imgSrc: "slider-2",
          imgText_En: "PROFESSION TEAM",
          path: "/companyteam",
          children: [],
        },
        {
          name: "联系我们",
          imgSrc: "slider-2",
          imgText_En: "CONTACT US",
          path: "/contactus",
          children: [],
        },
      ],
    };
  },
  mounted() {
    this.vantaEffect = FOG({
      el: this.$refs.vantaRef,
      THREE: THREE,
    });
    // 这里的FOG和引入的FOG和mounted中的FOG须保持一致
    VANTA.FOG({
      el: this.$refs.vantaRef,
      // 以下为样式配置
      mouseControls: true, // 鼠标控制
      touchControls: true, //触摸控制
      gyroControls: false, //陀螺仪控制
      minHeight: 200.0, // 最小高度
      minWidth: 200.0, //最小宽度
      highlightColor: 0x008cba, // 突出色调
      midtoneColor: 0x0094d9, // 中间色调
      lowlightColor: 0x00b4f4, // 暗色调
      baseColor: 0xffffff, // 低色调
      blurFactor: 0.52, // 模糊因素
      speed: 1.2, // 速度
      zoom: 0.3, // 变焦
    });
  },
  beforeDestroy() {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
    }
  },
  methods: {
    navClick(index, item) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = item.name;
      this.activeMenu = item;
      this.img = item.imgSrc;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$header-height: 120px;
/* 顶部 */
#header {
  transition: all ease 0.6s;
  width: 100%;
  height: 60vh;
  color: rgba($color: white, $alpha: 0.8);
  text-align: center;

  /* 导航栏 */
  .header-nav {
    height: $header-height;
    width: 100%;
    /* 导航栏logo */
    .header-nav-logo {
      width: 300px;
      height: 100%;
      float: left;
      position: relative;
      /* 导航栏logo图片 */
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .header-nav-wrapper {
      line-height: 110px;
      margin: 0;
      /* 导航栏 每个导航 */
      & > div {
        float: left;
        margin: 0 15px;
        position: relative;
        /* 导航栏 每个导航下面的 a 链接 */
        & > a {
          color: #fff;
          font-size: 16px;
          padding: 15px 0;
          position: relative;
          /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
          &:hover {
            color: $hover-color;
            text-decoration: none;
            /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
            & > .underline {
              opacity: 1;
              width: 100%;
              left: 0;
            }
            /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
            & > span {
              transform: rotate(180deg);
            }
          }
        }
        /* 导航栏 每个导航下面的 a 链接的下划线 */
        & > i {
          display: block;
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          opacity: 0;
          transition: all 0.6s ease;
          background-color: $hover-color;
        }
        /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
        & > span {
          font-size: 12px;
          transition: ease 0.5s;
        }
        /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
        &.active > a {
          color: $hover-color;
          text-decoration: none;
          border-bottom: 2px solid $hover-color;
          transition: all ease 6s;
        }
        &:hover > .second {
          transform: scaleY(1);
        }
      }
      /* 导航栏 滑上一级导航显示二级导航 */
      .second {
        position: fixed;
        z-index: 9999;
        width: 100vw;
        height: auto;
        top: 110px;
        left: 0;
        background: rgba($color: $header-background, $alpha: 0.8);
        transition: 1s;
        transform: scaleY(0);
        transform-origin: top;
        padding: 50px 300px;
        display: flex;
        flex-direction: column;
        & > .second-item {
          width: 250px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          & > a {
            color: $hover-color;
            &:hover {
              color: #fff;
              font-size: bold;
              color: #fff;
              /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
              & > .underline {
                opacity: 1;
                width: 100%;
                left: 0;
              }
              /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
              & > span {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
    }
    .header-nav-right {
      float: right;
    }
  }
  .bg-class {
    position: absolute;
    top: 0;
    width: 100%;
    height: 60vh;
    transition: all ease 0.6s;
  }
  .bg-text {
    position: absolute;
    top: 22%;
    width: 100%;
    text-align: center;
    font-size: 88px;
    letter-spacing: 50px;
  }
  .bg-text__index {
    position: absolute;
    top: 35%;
    width: 100%;
    font-size: 100px;
    text-align: center;
    color: $header-background;
    letter-spacing: 9px;
    color: white;
    text-shadow: 3px 3px rgba($color: rgb(80, 76, 76), $alpha: 0.6);
  }
}
.blur-out-contract {
  -webkit-animation: blur-out-contract 1s cubic-bezier(0.55, 0.085, 0.68, 0.53)
    reverse both;
  animation: blur-out-contract 1s cubic-bezier(0.55, 0.085, 0.68, 0.53) reverse
    both;
} /* ----------------------------------------------
 * Generated by Animista on 2025-1-13 14:52:6
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation blur-out-contract
 * ----------------------------------------
 */
@-webkit-keyframes blur-out-contract {
  0% {
    -webkit-filter: blur(0.01);
    filter: blur(0.01);
  }
  100% {
    letter-spacing: -0.5em;
    -webkit-filter: blur(12px) opacity(0%);
    filter: blur(12px) opacity(0%);
  }
}
@keyframes blur-out-contract {
  0% {
    -webkit-filter: blur(0.01);
    filter: blur(0.01);
  }
  100% {
    letter-spacing: -0.5em;
    -webkit-filter: blur(12px) opacity(0%);
    filter: blur(12px) opacity(0%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue